import { AlertTriangle, CircleAlert } from "lucide-react";
import type { RapportValidationScorecard } from "@repo/ent-struct";
import { libelleChemin } from "./edition";

/**
 * Récapitulatif des erreurs (elles bloquent la publication, pas
 * l'enregistrement) et des avertissements, en tête d'éditeur.
 */
export function BandeauValidation({
  rapport,
}: {
  rapport: RapportValidationScorecard;
}) {
  const { erreurs, avertissements } = rapport;
  if (erreurs.length === 0 && avertissements.length === 0) return null;

  return (
    <div className="space-y-2">
      {erreurs.length > 0 && (
        <div
          role="alert"
          className="rounded-surface border border-etat-erreur-trait bg-etat-erreur-surface p-3 text-sm"
        >
          <p className="mb-1 flex items-center gap-2 font-medium text-destructive">
            <CircleAlert className="h-4 w-4" />
            {erreurs.length} erreur{erreurs.length > 1 ? "s" : ""} à corriger
            avant de publier (l'enregistrement reste possible)
          </p>
          <ul className="list-inside list-disc space-y-0.5 text-muted-foreground">
            {erreurs.map((e, i) => (
              <li key={i}>
                <span className="font-medium text-foreground">
                  {libelleChemin(e.chemin)}
                </span>{" "}
                — {e.message}
              </li>
            ))}
          </ul>
        </div>
      )}
      {avertissements.map((a, i) => (
        <p
          key={i}
          className="flex items-center gap-2 rounded-surface border border-etat-alerte-trait bg-etat-alerte-surface p-3 text-sm text-etat-alerte-contenu"
        >
          <AlertTriangle className="h-4 w-4 shrink-0 text-etat-alerte" />
          {a.message}. La publication reste possible.
        </p>
      ))}
    </div>
  );
}
